/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BillingControlSubscriberPaymentQueueItem {
  amount?: number;
  attempt?: number;
  creditCardPaymentId?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  discountValue?: number;
  editionId?: number;
  email?: string;
  endOfCycle?: boolean;
  firstName?: string;
  gatewayId?: number;
  gatewayName?: string;
  installments?: number;
  lastMessage?: string;
  lastName?: string;
  origin?: string;
  paymentReference?: string;
  paymentRoundId?: number;
  personId?: number;
  priority?: number;
  recurrence?: number;
  shippingPrice?: number;
  step?: number;
  subscriberId?: number;
  subscriptionName?: string;
  subscriptionPrice?: number;
  subscriptionTypeId?: number;
  subscriptionTypeName?: string;
}
